var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',[_vm._v(_vm._s(_vm.$t('commonText.optional')))])}
var staticRenderFns = []

export { render, staticRenderFns }